import React from 'react';

import { Accordion } from '@change/ds-core-ui/Accordion';
import { Link } from '@change/ds-core-ui/Link';
import { Text } from '@change/ds-core-ui/Text';
import { FlagIcon } from '@change/ds-icons/FlagIcon';
import { SparkleIcon } from '@change/ds-icons/SparkleIcon';

import { isSsr } from '@change-corgi/core/ssr';
import { getWindow } from '@change-corgi/core/window';
import { Translate } from '@change-corgi/core-react/i18n';

import { ReportAbuseLink } from '#src/app/shared/components/abuse';

type Props = {
	content: string;
	onToggle: (expanded: boolean) => void;
	title: string;
	dataQa?: string;
};

export const AiAccordion: React.FC<Props> = ({ content, onToggle, title, dataQa }) => {
	return (
		<Accordion
			as="h2"
			data-qa={dataQa}
			title={title}
			onToggle={(_event, expanded) => {
				onToggle(expanded);
			}}
		>
			<div className="text-typography-strong flex flex-col items-start gap-4">
				<div className="bg-background-raised text-typography-weak mb-2 flex items-center gap-2 self-start rounded-md px-2 py-1">
					<SparkleIcon size="small" />
					<Translate value="corgi.components.ai_content.label" />
				</div>
				<Text as="p">{content}</Text>

				<ReportAbuseLink
					data-qa="topic-description-report-abuse-link"
					pageUrl={isSsr() ? undefined : getWindow().location.href}
					type="generic"
				>
					<Link leadingIcon={<FlagIcon />} size="small" variant="primary" as="button">
						<Translate value="fe.pages.decision_maker_show.ai_content.report_issue_label" />
					</Link>
				</ReportAbuseLink>
			</div>
		</Accordion>
	);
};
